export const stationDistanceList = [
    {
        id: 0,
        value: '指定なし'
    },
    {
        id: 3,
        value: '3分以内'
    },
    {
        id: 5,
        value: '5分以内'
    },
    {
        id: 7,
        value: '7分以内'
    },
    {
        id: 10,
        value: '10分以内'
    },
    {
        id: 15,
        value: '15分以内'
    },
    {
        id: 20,
        value: '20分以内'
    }
]